import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/common/lot-pdf.svg'
import _imports_1 from '@/assets/images/common/lot-video.svg'


const _hoisted_1 = ["src", "alt", "width", "height"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["width", "height"]
const _hoisted_4 = ["href"]
const _hoisted_5 = ["width", "height"]
const _hoisted_6 = {
  key: 1,
  class: "count-images"
}

import { useAuctionStore } from "@/stores/AuctionStore";
  import { computed, nextTick, ref, watch } from "vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import type { Swiper as SwiperSlider } from "swiper/types";
  import { LotFileTypes } from "@/enum";
  import { isObject } from "lodash";
  import { isScreenL } from "@/utils/media-size";
  import { IMessage } from "@/models";
  import PinnedMessage from "@/components/_partials/PinnedMessage.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotGallery',
  setup(__props) {

  const swiperMain = ref<SwiperSlider | null>(null);
  const swiperThumbs = ref<SwiperSlider | null>(null);
  const activeImageIndex = ref(1);

  const newMessage = ref<IMessage | null>(null);
  const user = computed(() => auctionStore.user);

  const gallerySize = computed(() => {
    if (auctionStore.user?.is_admin) {
      return { width: 290, height: 373 };
    } else {
      return { width: 403, height: 517 };
    }
  });

  const auctionStore = useAuctionStore();
  const activeLot = computed(() => (auctionStore.activeLot?.id ? auctionStore.activeLot : auctionStore.fakeActiveLot));
  const files = computed(() => {
    return isObject(activeLot.value?.files) ? Object.values(activeLot.value?.files) || [] : [];
  });

  const onSliderInit = (swiper: SwiperSlider) => {
    swiperMain.value = swiper;
  };

  const changeActiveIndexSlide = (index: number) => {
    // For looped sliders, use realIndex from swiperMain to get correct position
    if (swiperMain.value) {
      const realIdx = swiperMain.value.realIndex ?? swiperMain.value.activeIndex ?? index;
      // Adding 1 because swiper indices start from 0, but we display 1-based numbering
      activeImageIndex.value = realIdx + 1;
    } else {
      activeImageIndex.value = index + 1;
    }
  };

  const onSliderInitThumbs = (swiper: SwiperSlider) => {
    swiperThumbs.value = swiper;
  };

  watch(
    () => activeLot.value?.id,
    () => {
      // Reset index when lot changes (swiper components will be recreated due to :key)
      activeImageIndex.value = 1;
    }
  );

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PinnedMessage, {
      hidden: user.value?.is_admin || !_unref(isScreenL)
    }, null, 8, ["hidden"]),
    (_openBlock(), _createBlock(Swiper, _mergeProps({
      key: `main-${activeLot.value?.id}`
    }, _ctx.$attrs, {
      "slides-per-view": 1,
      "space-between": 20,
      pagination: false,
      navigation: files.value.length > 1,
      scrollbar: false,
      loop: true,
      "thumbs-swiper": '.swiper-bullets .swiper-wrapper',
      "check-active-index": true,
      type: "mainLotGallery",
      class: "with-main-bullets main-lot-gallery-swiper",
      init: "false",
      onSwiperInit: onSliderInit,
      onUpdateActiveSlideIndex: _cache[0] || (_cache[0] = (i) => changeActiveIndexSlide(i))
    }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, {
            key: file.src,
            class: "swiper-slide"
          }, {
            default: _withCtx(() => [
              (file.type == _unref(LotFileTypes).IMAGE)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: file.src,
                    class: "img",
                    alt: file.src,
                    width: gallerySize.value.width,
                    height: gallerySize.value.height
                  }, null, 8, _hoisted_1))
                : (file.type == _unref(LotFileTypes).PDF)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: file.src,
                      class: "magnifier-zoom-image",
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "img",
                        alt: "pdf",
                        width: gallerySize.value.width,
                        height: gallerySize.value.height
                      }, null, 8, _hoisted_3)
                    ], 8, _hoisted_2))
                  : (file.type == _unref(LotFileTypes).VIDEO)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: file.src,
                        class: "magnifier-zoom-image",
                        target: "_blank"
                      }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "img",
                          alt: "video",
                          width: gallerySize.value.width,
                          height: gallerySize.value.height
                        }, null, 8, _hoisted_5)
                      ], 8, _hoisted_4))
                    : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 16, ["navigation"])),
    (files.value.length > 1)
      ? (_openBlock(), _createBlock(Swiper, {
          key: `thumbs-${activeLot.value?.id}`,
          "slides-per-view": 5,
          "space-between": 10,
          pagination: false,
          navigation: false,
          scrollbar: false,
          loop: files.value.length > 5,
          type: "mainLotGalleryBullets",
          class: "swiper-wrapper swiper-bullets",
          init: "false",
          onSwiperInit: onSliderInitThumbs
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: `thumb-${file.src}`,
                class: "swiper-pagination-bullet swiper-slide"
              }))
            }), 128))
          ]),
          _: 1
        }, 8, ["loop"]))
      : _createCommentVNode("", true),
    (files.value.length > 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(activeImageIndex.value) + "/" + _toDisplayString(files.value.length) + " images ", 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})